import { render, staticRenderFns } from "./EditPlan.vue?vue&type=template&id=90957e66&"
import script from "./EditPlan.vue?vue&type=script&lang=js&"
export * from "./EditPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports